import React from 'react';

import {
  required,
} from 'react-admin';

import { capitalize, Grid } from '@mui/material';

import { Alpha3Code } from 'i18n-iso-countries';

import TextInput from '../../../../../../layout/inputFields/TextField';
import SelectInput from '../../../../../../layout/inputFields/SelectInput';
import InfoPopover from '../../../../../../layout/InfoPopover';

import countries from '../../../../../../../constants/countries';
import { FundsTypes, fundsTypesChoices } from '../../../../../../../constants/fundsTypes';
import currencies, { Currencies } from '../../../../../../../constants/currencies';

export type TransactionPartyRootFormValues = {
  country: Alpha3Code;
  foreign_currency: Currencies;
  funds_code: FundsTypes;
  funds_comment?: string;
}

const RootFields = ({
  direction,
}: {
  direction: string;
}) => (
  <Grid container spacing={6}>
    <Grid
      size={{
        xs: 12,
        sm: 6,
        md: 3,
      }}
    >
      <SelectInput
        label={`${capitalize(direction!)} country`}
        fullWidth
        source={`${direction}.country`}
        choices={[...countries, { id: 'unknown', name: 'Unknown' }]}
        validate={required()}
      />
    </Grid>
    <Grid
      size={{
        xs: 12,
        sm: 6,
        md: 3,
      }}
    >
      <SelectInput
        choices={currencies.map((currency) => ({ id: currency, name: currency }))}
        label={`${capitalize(direction!)} currency`}
        source={`${direction}.foreign_currency`}
        validate={required()}
        fullWidth
      />
    </Grid>
    <Grid
      size={{
        xs: 12,
        sm: 6,
        md: 3,
      }}
    >
      <SelectInput
        choices={fundsTypesChoices}
        label="Carrier of transaction"
        source={`${direction}.funds_code`}
        validate={required()}
        fullWidth
        popups={(
          <InfoPopover
            title="Carrier of transaction"
            content="Channel used to execute the transaction. When no carrier has been used, “Not relevant” should be selected."
          />
        )}
      />
    </Grid>
    <Grid
      size={{
        xs: 12,
        sm: 6,
        md: 3,
      }}
    >
      <TextInput
        fullWidth
        source={`${direction}.funds_comment`}
        label="Reference for Carrier of transactions"
        popups={(
          <InfoPopover
            title="Reference for Carrier of transactions"
            content="Could for example be: telephone number for swish, card number for card terminal, bankgiro for BankGiro transaction."
          />
        )}
      />
    </Grid>
  </Grid>
);

export default RootFields;
